import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../core-ui/core-ui.module';
import { FeedbackTagComponent } from './feedback-tag.component';

@NgModule({
    imports: [CommonModule, CoreUiModule],
    declarations: [FeedbackTagComponent],
    exports: [FeedbackTagComponent]
})
export class FeedbackTagModule {}
